import { MissionEventHandler } from "../mission"

export default class ProgressBar extends MissionEventHandler {
  constructor(mission, rootElement) {
    super(mission)

    this.root = rootElement

    this.handleMouseOver = this.handleMouseOver.bind(this)
    this.handleMouseClick = this.handleMouseClick.bind(this)
    this.handleGoToLive = this.handleGoToLive.bind(this)
    this.handlePlayPauseClick = this.handlePlayPauseClick.bind(this)

    this.root.addEventListener("mousemove", this.handleMouseOver)
    this.root.addEventListener("click", this.handleMouseClick)

    if (this.mission.history.length > 0) this.show()

    // Main replay bars
    this.timelineBox = document.getElementById("timelineBox")
    this.selectionBox = this.timelineBox.querySelector(".timelineSelection")
    this.tooltip = this.root.getElementsByClassName("timelineTooltip")[0]
    this.timelinePlayed = this.root.getElementsByClassName("timelinePlayed")[0]

    // GoToLive area
    this.goToLive = this.root.getElementsByClassName("goToLive")[0]
    this.goToLive.addEventListener("click", this.handleGoToLive)
    this.liveConnectionElement = this.root.getElementsByClassName("liveConnection")[0]

    // Play Pause area
    this.playPauseElement = this.root.getElementsByClassName("playPause")[0]
    this.playElement = this.playPauseElement.getElementsByClassName("play")[0]
    this.pauseElement = this.playPauseElement.getElementsByClassName("pause")[0]
    this.replayElement = this.playPauseElement.getElementsByClassName("replay")[0]

    this.playPauseElement.addEventListener('click', this.handlePlayPauseClick)
  }

  drawPlayedLine() {
    this.timelinePlayed.style.width = `${this.mission.replayInfo.currentIndex / (this.mission.history.length - 1) * 100}%`
  }

  handleMissionHistoryAppend(message) {
    this.show()

    this.drawPlayedLine()
  }

  handleMissionIndexJump(jumpIndex) {
    this.show()

    this.drawPlayedLine()
  }

  handleMissionStep(message) {
    this.show()

    this.drawPlayedLine()
  }

  handleMissionHistoryLoad() {
    console.log("We are doing the history")
    this.show()
  }

  handleSyncCompleted() {
    this.show()
  }

  handleMouseOver(event) {

    const bounds = this.timelineBox.getBoundingClientRect()
    const posX = event.clientX - bounds.left
    const percent = posX / bounds.width
    if (percent >= 1 || percent < 0) return

    this.selectionBox.style.width = `${percent * 100}%`


    const index = Math.floor(this.mission.history.length * percent)
    if (!this.mission.history[index]) return

    this.tooltip.innerHTML = "<div>" + new Date(this.mission.history[index].timestamp).toLocaleTimeString() + "</div>"
    this.tooltip.style.top = `${bounds.top - 70}px`
    this.tooltip.style.left = `${event.clientX - this.tooltip.getBoundingClientRect().width / 2}px`
  }

  handleMouseClick(event) {
    if (event.target?.className == "roamDot") {
      console.log("Skipping a roam click")
      return
    }

    if (event.target.closest(".goToLive")) {
      return
    }
    const bounds = this.timelineBox.getBoundingClientRect()
    const posX = event.clientX - bounds.left
    const percent = posX / bounds.width
    if (percent >= 1 || percent < 0) return

    this.mission.setReplayIndex(Math.floor(this.mission.history.length * percent))
  }

  handlePlayPauseClick(event) {
    if (!this.mission.isReplaying && !this.mission.isLive) {
      this.mission.startReplay()
      return
    }

    this.mission.isReplayPaused = !this.mission.isReplayPaused

    this.show()
  }

  show() {
    this.root.style.display = null

    this.playElement.style.display = 'none'
    this.pauseElement.style.display = 'none'
    this.replayElement.style.display = 'none'
    this.goToLive.style.display =  'none'
    this.liveConnectionElement.style.display = 'none'

    if (this.mission.isLive && this.mission.isReplaying) {
      this.goToLive.style.display =  'block'
    }

    if (!this.mission.isReplaying && !this.mission.isLive) {
      this.replayElement.style.display = 'block'
      return
    }

    if (!this.mission.isReplaying && this.mission.isLive) {
      this.liveConnectionElement.style.display = 'block'
    }

    if (this.mission.isReplayPaused) {
      this.playElement.style.display = 'block'
    } else {
      this.pauseElement.style.display = 'block'
    }
  }

  hide() {
    this.root.style.display = 'none'
  }

  handleGoToLive(event) {
    this.mission.setReplayIndex(this.mission.history.length - 1)
  }

  cleanup() {
    super.cleanup()
    this.hide()
    this.goToLive.removeEventListener("click", this.handleGoToLive)
    this.root.removeEventListener("mousemove", this.handleMouseOver)
    this.root.removeEventListener("click", this.handleMouseClick)
  }
}